module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "UserInvite"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('contact')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9"
  }, [_c('div', {
    staticClass: "card standard-card"
  }, [_c('h4', [_vm._v("Wypełnij brakujące informacje")]), _vm._v(" "), _c('AccountDetailsForm', {
    on: {
      "sendSuccess": _vm.showSuccessModal
    }
  })], 1)])]), _vm._v(" "), (_vm.showModal) ? _c('modal-success-account-details', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "close": _vm.closeSuccessModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-039b2303","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/accountDetails.vue
// module id = 355
// module chunks = 0